import {css} from "@panda/css";

import {CheckboxControlled} from "@pg-design/rhf-components-module";
import {Text} from "@pg-design/text-module";

import {mktOptinsCopy} from "../../../application/constants/lead/mkt_optins_copy";

export const RegistrationMktOptins = () => {
    return (
        <div className={wrapperStyle}>
            <Text variant="info_txt_3" as="span">
                Zgoda na komunikację marketingową:
            </Text>
            <div className={checkboxesStyle}>
                <CheckboxControlled name="marketing_email" id="registration_marketing_email" labelContent="E-mail" checkedMarkColor="#02D054" />
                <CheckboxControlled name="marketing_sms" id="registration_marketing_sms" labelContent="Telefon" checkedMarkColor="#02D054" />
            </div>
            <Text variant="info_txt_3" as="span" color="var(--colors-secondary)">
                {mktOptinsCopy}
            </Text>
        </div>
    );
};

const wrapperStyle = css({
    display: "flex",
    flexDirection: "column",
    gap: 1
});

const checkboxesStyle = css({
    display: "flex",
    flexDirection: "row",
    gap: 3
});
import {css} from "@panda/css";

import {CheckboxControlled} from "@pg-design/rhf-components-module";
import {Text} from "@pg-design/text-module";

import {mktOptinsCopy} from "../../../application/constants/lead/mkt_optins_copy";

export const RegistrationMktOptins = () => {
    return (
        <div className={wrapperStyle}>
            <Text variant="info_txt_3" as="span">
                Zgoda na komunikację marketingową:
            </Text>
            <div className={checkboxesStyle}>
                <CheckboxControlled name="marketing_email" id="registration_marketing_email" labelContent="E-mail" checkedMarkColor="#02D054" />
                <CheckboxControlled name="marketing_sms" id="registration_marketing_sms" labelContent="Telefon" checkedMarkColor="#02D054" />
            </div>
            <Text variant="info_txt_3" as="span" color="var(--colors-secondary)">
                {mktOptinsCopy}
            </Text>
        </div>
    );
};

const wrapperStyle = css({
    display: "flex",
    flexDirection: "column",
    gap: 1
});

const checkboxesStyle = css({
    display: "flex",
    flexDirection: "row",
    gap: 3
});
